import { SVGAttributes } from 'react';
import { VariantProps } from 'tailwind-variants';
import { radioStyles } from '../../styles';

export interface IRadioFieldIconProps
  extends VariantProps<typeof radioStyles.icon> {
  className?: string;
  disabled?: boolean;
  rest?: Omit<SVGAttributes<SVGElement>, 'className'>;
}

export function RadioFieldIcon({
  className,
  design,
  disabled,
  size,
  ...rest
}: IRadioFieldIconProps) {
  return (
    <svg
      aria-labelledby="radio check"
      className={radioStyles.icon({
        className,
        disabled,
        design,
        size,
      })}
      fill="none"
      role="graphics-symbol"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <title id="title-1">Circle Shape</title>
      <desc id="description-1">
        Circle shape to indicate whether the radio input is checked or not.
      </desc>
      <circle cx="8" cy="8" r="4" />
    </svg>
  );
}
